import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Input from '../../../components/Input/Input';
import AutocompleteComponent from '../../../components/layout/Autocomplete';
import DatePickerComponent from '../../../components/layout/DatePicker';
import { useGetLocalidadesPrestadoresQuery } from '../../../services/periodicosApi';
import { useGetProvincesQuery } from '../../../services/companyApi';

interface AvisoObraFiltersProps {
    extraFilters: any;
    handleChangeExtraFilters: (e: any) => void;
}

const AvisoObraFilters = ({ extraFilters, handleChangeExtraFilters }: AvisoObraFiltersProps) => {
    const { t } = useTranslation('avisoObra');
    const { data: localidadesOptions, isLoading: isLoadingLocalidades } =
        useGetLocalidadesPrestadoresQuery({});
    const { data: provincesData, isLoading: isLoadingProvincias } = useGetProvincesQuery(null);
    const provincesList = provincesData?.data?.provincias || [];

    return (
        <>
            <Grid item xs={2.2}>
                <Input
                    size="small"
                    label={t('filters.nroObra')?.toString() || ''}
                    name="nroObra"
                    value={extraFilters?.nroObra || ''}
                    onChange={handleChangeExtraFilters}
                    clearable
                />
            </Grid>
            <Grid item xs={2.2}>
                <AutocompleteComponent
                    size="small"
                    label={t('filters.localidad')}
                    name="localidad"
                    value={extraFilters?.localidad || null}
                    onChange={(value: any) =>
                        handleChangeExtraFilters({
                            target: {
                                name: 'localidad',
                                value: value
                            }
                        })
                    }
                    options={localidadesOptions || []}
                    loading={isLoadingLocalidades}
                    templateLabel={(item: any) => item?.nombre}
                    clearable
                />
            </Grid>

            <Grid item xs={2}>
                <AutocompleteComponent
                    size="small"
                    label={t('filters.provincia')}
                    name="provincia"
                    value={extraFilters?.provincia || null}
                    onChange={(value: any) =>
                        handleChangeExtraFilters({
                            target: {
                                name: 'provincia',
                                value: value
                            }
                        })
                    }
                    options={provincesList || []}
                    loading={isLoadingProvincias}
                    templateLabel={(item: any) => item?.nombre}
                    clearable
                />
            </Grid>

            <Grid item xs={2}>
                <AutocompleteComponent
                    size="small"
                    label={t('filters.estado')}
                    name="estado"
                    value={extraFilters?.estado || ''}
                    onChange={(value: any) =>
                        handleChangeExtraFilters({
                            target: {
                                name: 'estado',
                                value: value
                            }
                        })
                    }
                    options={[
                        { id: 'borrador', nombre: 'Borrador' },
                        { id: 'enRevision', nombre: 'En Revisión' },
                        { id: 'aprobado', nombre: 'Aprobado' },
                        { id: 'suspendido', nombre: 'Suspendido' }
                    ]}
                    templateLabel={(item: any) => item?.nombre}
                    clearable
                />
            </Grid>
            <Grid item xs={2}>
                <DatePickerComponent
                    size="small"
                    label={t('filters.fechaInicio')}
                    name="fechaInicio"
                    value={extraFilters?.fechaInicio || ''}
                    onChange={(value: any) =>
                        handleChangeExtraFilters({
                            target: {
                                name: 'fechaInicio',
                                value
                            }
                        })
                    }
                    clearable
                />
            </Grid>
            <Grid item xs={2}>
                <DatePickerComponent
                    size="small"
                    label={t('filters.fechaFin')}
                    name="fechaFin"
                    value={extraFilters?.fechaFin || ''}
                    onChange={(value: any) =>
                        handleChangeExtraFilters({
                            target: {
                                name: 'fechaFin',
                                value
                            }
                        })
                    }
                    clearable
                />
            </Grid>
        </>
    );
};

export default AvisoObraFilters;
